<template>
  <a-layout>
    <a-card :bordered="false">
      <div class='mb10 s_flex_ali'>
        <span class='mr15'>
          <a-button type="primary" @click="create">
            <PlusOutlined />
            添加奖项
          </a-button>
        </span>
      </div>
      <div class="s_c999 mb10 " style="text-align:right"> 
        <span class="s_c333">二维码数量：</span>{{code_num}} 
        <span class="s_c333 m-l-10">综合中奖率：</span> 
        <span v-if="template_type != 7">{{award_percent}}%</span> 
        <span v-else>-</span> <!--游戏模板奖项不设置奖项数量，无法计算综合中奖率，综合中奖率显示“-”-->
        <a-tooltip placement='left' :overlayStyle="{'max-width':'500px'}">
          <template #title>
            综合中奖率达到100%，全部奖项通过比例计算的中奖码数量差值将添加到中奖率最大的奖项中，中奖率相同添加到最先添加的奖项中。 
            <br/>
            例如：总二维码数量：100个，奖项A中奖率33.3%=33数量，奖项B中奖率33.3%=33数量，奖项C中奖率33.4%=33数量，差值（1个）将添加到奖项C中。结果：奖项A中奖数量33个，奖项B中奖数量33个，奖项C中奖数量34个。
            <br/>
            使用点球大战游戏模板时按照用户进球数发奖，用户踢进球后必得进球数
          </template>
          <QuestionCircleOutlined class="s_c376 m-l-5" />
        </a-tooltip>
      </div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='award_id' :columns='columns'
        :data-source='list' :scroll="{ x: 'max-content'}">
        <template #numTitle>
          {{template_type != 7?'中奖码数量':'进球数'}}
        </template>
        <template #percentTitle>
          {{template_type != 7?'中奖率':'进球概率'}}
        </template>
        <template #award_num="{ record }">
          <p v-if="template_type != 7">{{record.award_num}}</p>
          <p v-else>{{record.award_type==1?'-':('第'+record.award_num+'球')}}</p>
        </template>
        <template #percent="{ record }">
          <p v-if="template_type != 7">{{record.percent}}</p>
          <p v-else>{{record.award_num==0?'-':record.percent}}</p>
        </template>
        <template v-slot:is_ploy="{ record }">
          {{record.is_ploy?'是':'否'}}
        </template>
        <template v-slot:action="{ record }">
          <a-popconfirm title="确定要删除该奖项么？" @confirm="del(record)" ok-text="删除" cancel-text="取消" placement="topRight">
            <a-button type="danger" size="small" href="javascript:;" v-if="record.award_type!=1&&template_type!=7">删除</a-button>
          </a-popconfirm>
          <a-button type="primary" size="small" href="javascript:;" class="m-l-10" @click="edit(record)"
            v-if="record.award_type!=1">修改</a-button>
          <a-button size="small" href="javascript:;" class="m-l-10" @click="additionalShow(record)"
            v-if="record.award_type!=1&&template_type!=7">附加奖项设置</a-button>
        </template>
      </a-table>
      <div class="s_flex_center">
        <a-button @click="provide()" class="  m-t-20 m-r-20">上一步</a-button>
        <a-button type="primary" @click="next()" class="  m-t-20 ">下一步</a-button>
      </div>
    </a-card>
  </a-layout>
  <!-- 附加奖 -->
  <a-modal v-model:visible="additionalVisible" :width="1000" destroyOnClose centered title="附加奖设置" :footer="null">
    <additional :award_id="additionalData.award_id" :activity_id="activity_id" title="附加奖设置" />
  </a-modal>
  <a-modal :keyboard="false" v-model:visible="visible" title="活动奖项" centered style="width:700px;" :width='1000'
    @ok="handleOk" destroyOnClose :confirm-loading="confirmLoading">
    <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:4}">
      <a-form-item label="奖项名称" name='award_name' required>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.award_name" placeholder="如: 一等奖"></a-input>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="进球数" required v-if="template_type == 7">
        第{{form.award_num}}球
        <a-tooltip placement='right' :overlayStyle="{'max-width':'300px'}">
          <template #title>
            用户踢进当前数量的球可获得奖励提示： 
            <br/>
            1、为向用户提供更好的开奖体验建议您设置奖项时按照进球数设置递增价值的奖项；
            <br/>
            2、“第0球”表示当前活动的必得基础奖项。
          </template>
          <QuestionCircleOutlined class="s_c376 m-l-10" />
        </a-tooltip>
      </a-form-item>
      <a-form-item label="进球概率" name='percentBall' required v-if="template_type == 7">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input-number :min="0" :max="100" v-model:value="form.percent" style="width:100%" :disabled="form.award_num==0" placeholder='请设置进球概率' />
          </a-col>
          <a-col :span="12"> % </a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="奖项数量类型" required v-if="template_type != 7">
        <a-radio-group name="quantity_type"
          v-model:value="form.quantity_type">
          <a-radio :value="1">按比例</a-radio>
          <a-radio :value="2">按数量</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :label="form.quantity_type==2?'奖项数量':'奖项比例'" v-if="template_type != 7">
        <a-row :gutter="16" v-if="form.quantity_type==1">
          <a-col :span="12">
            <a-input-number :min="0" :max="100"
              v-model:value="form.percent" style="width:100%" placeholder='请输入奖项比例' />
          </a-col>
          <a-col :span="12">
            % 奖项数量：{{Math.ceil(numData.total*form.percent/100)}}
          </a-col>
        </a-row>
        <a-input-number v-model:value="form.award_num" :precision="0"
          style="width:200px" placeholder='请输入奖项数量' :min="numData.min_num" :max="numData.max_num" v-else />
        <div class="ant-form-explain">当前所选范围的码总数：{{numData.total}}， 未分配数量：{{numData.assig_num}}
          ，当前可设置最大数：{{numData.max_num}} ，最小数：{{numData.min_num}}</div>
        <div class="ant-form-explain" style="color:#f04635">当使用大转盘模板时,第八个奖规定必须百分百中奖</div>
      </a-form-item>
      <a-form-item label="奖项图标" required prop="award_img">
        <ul>
          <li><input id="coupons" type="radio" v-model="form.award_img" value="/web_base_assets/scan/coupons.png" hidden
              name="award_img" />
            <label for="coupons">
              <img :src="info.picdomain+'/web_base_assets/scan/coupons.png'" alt="" style="width:100%">
            </label>
          </li>
          <li><input id="cut" type="radio" v-model="form.award_img" value="/web_base_assets/scan/cut.png" hidden
              name="award_img" />
            <label for="cut">
              <img :src="info.picdomain+'/web_base_assets/scan/cut.png'" alt="" style="width:100%">
            </label>
          </li>
          <li><input id="jf" type="radio" v-model="form.award_img" value="/web_base_assets/scan/jf.png" hidden
              name="award_img" />
            <label for="jf">
              <img :src="info.picdomain+'/web_base_assets/scan/jf.png'" alt="" style="width:100%">
            </label>
          </li>
          <li><input id="reb" type="radio" v-model="form.award_img" value="/web_base_assets/scan/reb.png" hidden
              name="award_img" />
            <label for="reb">
              <img :src="info.picdomain+'/web_base_assets/scan/reb.png'" alt="" style="width:100%">
            </label>
          </li>
          <li>
            <input id="material" type="radio" :checked="form.award_bg==form.award_img" hidden :value="form.award_bg"
              name="award_img" />
            <label for="material">
              <material :groupType='1' :image="form.award_bg" :max="1"
                v-on:handlechoose="(data)=>{form.award_img=data;form.award_bg=data}"
                v-on:handledel="form.award_img='';form.award_bg=''" />
            </label>
          </li>
        </ul>
      </a-form-item>
      <a-form-item label="奖项是否仅策略" v-if="template_type != 7">
        <a-switch v-model:checked="form.is_ploy" :checkedValue="1" :unCheckedValue="0"></a-switch>
      </a-form-item>
      <a-form-item label="奖项内容" :wrapper-col="{span:19}" required>
        <div>
          <a-checkbox v-model:checked="form.is_bonus" @change="(e)=>changAwardContent(e,'is_bonus')">红包</a-checkbox>
          <a-checkbox v-model:checked="form.is_point" @change="(e)=>changAwardContent(e,'is_point')">积分</a-checkbox>
          <a-checkbox v-model:checked="form.is_gift" @change="(e)=>changAwardContent(e,'is_gift')">礼品</a-checkbox>
          <a-checkbox v-model:checked="form.is_coupon" @change="(e)=>changAwardContent(e,'is_coupon')">优惠卷</a-checkbox>
        </div>
        <a-tabs v-if="panes.length" style="margin-top:10px">
          <a-tab-pane v-for="pane in panes" :key="pane.key" :tab="pane.title" forceRender>
            <div v-if="pane.type=='is_point'">
              <isPoint v-if="pane.type=='is_point'" :point_num="form.point_num" v-model:value="form.point_num"
                ref="point" />
            </div>
            <div v-if="pane.type=='is_gift'">
              <isGift v-if="pane.type=='is_gift'" :giftDetail="giftDetail" ref="giftCompoents"
                v-on:giftDone="giftDone" />
            </div>
            <div v-if="pane.type=='is_bonus'">
              <isBonus v-if="pane.type=='is_bonus'" ref="bonus" v-model:value="form.bonus_id"
                v-model:content="form.bonus_content" :bonus_id="form.bonus_id" :bonus_content="form.bonus_content" />
            </div>
            <div v-if="pane.type=='is_coupon'">
              <isCoupon v-if="pane.type=='is_coupon'" ref="coupon" v-model:couponName="form.coupon_name"
                v-model:content="form.coupon_content" :content="form.coupon_content" :couponName="form.coupon_name" />
            </div>

          </a-tab-pane>
        </a-tabs>
      </a-form-item>
      <a-form-item label="多奖项发放概率" :wrapper-col="{span:20}" v-if="panes.length>1">
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_many_percent"></a-switch>
        <br />
        <div class="p-l-15 p-r-15 p-t-5 p-b-5" style="background-color:#f2f2f2;" v-if="form.is_many_percent">
          <a-form-item label="积分发放几率" v-if="form.is_point">
            <a-input-number class="m-r-10" v-model:value="form.point_percent" :max="100" :min="1"
              :disabled="form.point_is_hit"></a-input-number>%
            <a-switch :checkedValue="1" :unCheckedValue="0" style='margin-left: 5px;margin-right:5px'
              v-model:checked="form.point_is_hit" @change="changHit('point_is_hit')"></a-switch> 必得奖项
          </a-form-item>
          <a-form-item label="礼品发放几率" v-if="form.is_gift">
            <a-input-number class="m-r-10" v-model:value="form.gift_percent" :max="100" :min="1"
              :disabled="form.gift_is_hit"></a-input-number>% <a-switch :checkedValue="1" :unCheckedValue="0"
              style='margin-left: 5px;margin-right:5px' v-model:checked="form.gift_is_hit"
              @change="changHit('gift_is_hit')"></a-switch> 必得奖项
          </a-form-item>
          <a-form-item label="红包发放几率" v-if="form.is_bonus">
            <a-input-number class="m-r-10" v-model:value="form.bonus_percent" :max="100" :min="1"
              :disabled="form.bonus_is_hit"></a-input-number>% <a-switch :checkedValue="1" :unCheckedValue="0"
              style='margin-left: 5px;margin-right:5px' v-model:checked="form.bonus_is_hit"
              @change="changHit('bonus_is_hit')"></a-switch> 必得奖项
          </a-form-item>
          <a-form-item label="优惠券发放几率" v-if="form.is_coupon">
            <a-input-number class="m-r-10" v-model:value="form.coupon_percent" :max="100" :min="1"
              :disabled="form.coupon_is_hit"></a-input-number>% <a-switch :checkedValue="1" :unCheckedValue="0"
              style='margin-left: 5px;margin-right:5px' v-model:checked="form.coupon_is_hit"
              @change="changHit('bonus_is_hit')"></a-switch> 必得奖项
          </a-form-item>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
  import {
    activitysTreeList,
    activitysTreeCreate,
    activitysNum,
    activitysTreeDel,
    activitysTreeDetail,
    activitysTreeUpdate,
    getBallNum
  } from "@/api/qrcodeActivitys";
  import { PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { onMounted, reactive, ref, toRefs } from "vue";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import isPoint from "./components/isPoint";
  import isGift from "./components/isGift";
  import isBonus from "./components/isBonus";
  import isCoupon from "./components/isCoupon";
  import additional from './components/additional'//附加奖
  import store from "@/store";
  const labelCol = { span: 3 };
  const wrapperCol = { span: 9 };
  const def = {
    award_img: "",
    is_bonus: 0,
    is_gift: 0,
    is_point: 0,
    quantity_type: 1,
    point_num: "",
    percent: 0,
    award_num: "",
    award_name: "",
    is_many_percent: "",
    bonus_content: "", //红包的描述
    gift_content: "", //礼品的描述
    gift_express_content: "", //快递的描述
    bonus_is_hit: false,
    gift_is_hit: false,
    point_is_hit: false,
    award_percent: "", //综合中奖率
    is_coupon: 0, //是否有卷 1 有
    coupon_percent: "", // 多奖项概率:卷概率
    coupon_is_hit: false, // 多奖项概率:卷是否必中
  };
  let columns = [
    {
      title: "奖项名称",
      dataIndex: "award_name",
      key: "award_name",
    },
    {
      dataIndex: "award_num",
      key: "award_num",
      slots: { title: 'numTitle',customRender: 'award_num' },
    },
    {
      key: "percent",
      dataIndex: "percent",
      slots: { title: 'percentTitle',customRender: 'percent' },
    },
    {
      title: "奖项内容",
      dataIndex: "award_content",
      key: "award_content",
    },
    {
      title: "已中奖数量",
      dataIndex: "award_sure_num",
      key: "award_sure_num",
    },
    {
      title: "是否仅策略发奖",
      dataIndex: "is_ploy",
      key: "is_ploy",
      slots: { customRender: "is_ploy" },
    },
    {
      title: "操作",
      key: "action",
      width: 250,
      slots: { customRender: "action" },
    },
  ];
  const validateContent = (rule, value, callback) => {
    console.log(rule, value);
    callback();
  };
  export default {
    name: "tree",
    components: {
      PlusOutlined,
      isBonus,
      isGift,
      isPoint,
      isCoupon,
      QuestionCircleOutlined,
      additional
    },
    props: {
      activity_id: {
        type: Number,
        default: () => {
          return null;
        },
      },
    },
    setup(props, { emit }) {
      let percentBall = async () => {
        if (state.template_type == 7 && !isNumber(form.value.percent)) {
          return Promise.reject("请输入进球概率");
        } else {
          return Promise.resolve();
        }
      };
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      
  
      const rules = {
        award_name: [
          {
            required: true,
            message: "请输入奖项名称",
          },
        ],
        award_img: [
          {
            required: true,
            message: "请选择奖项图标",
          },
        ],
        quantity_type: [
          {
            type: "array",
            required: true,
            message: "请选择奖项比例",
          },
        ],
        percentBall:[{ required: true, validator: percentBall }]

      };
      // 奖项面板
      const state = reactive({
        additionalVisible: false,//附加奖弹窗
        additionalData: {},//附加奖数据
        template_type: "", //模板类型
      });
      const panes = ref([]);
      const form = ref(JSON.parse(JSON.stringify(def)));
      const ruleForm = ref();
      const listLoading = ref(true);
      const list = ref([]);
      const visible = ref(false);
      const confirmLoading = ref(false);
      // 切换奖项内容checkBox
      const changAwardContent = (e, type) => {
        if (e.target.checked) {
          panes.value.push({
            title:
              type == "is_gift"
                ? "礼品"
                : type == "is_point"
                  ? "积分"
                  : type == "is_coupon"
                    ? "优惠卷"
                    : "红包",
            type: type,
            key: type,
          });
        } else {
          panes.value = panes.value.filter((v) => v.type != type);
        }
      };
      const award_id = ref("");
      // 获取第几球数
      const getGoalsNum = async () => {
        let result = await getBallNum(props.activity_id).then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          visible.value = true;
          form.value.award_num = result.data.award_num;
          form.value.percent = result.data.award_num==0?100:50;
        }else{
          message.error(result.message);
        }
      };
      const create = async () => {
        award_id.value = null;
        // 大转盘只能添加7个奖项
        if (
          state.template_type &&
          state.template_type == 4 &&
          list.value.length >= 8
        ) {
          message.error("大转盘模板最多添加8个奖项");
          return;
        }
        // 点球只能添加10个奖项
        if (
          state.template_type &&
          state.template_type == 7 &&
          list.value.length >= 10
        ) {
          message.error("奖项数量超限制~");
          return;
        }
        if(state.template_type != 7){
          await getActivitysNum();
        }
        form.value = {
          is_bonus: 0,
          is_gift: 0,
          is_point: 0,
          quantity_type: 1,
          percent: 0,
          award_num: "",
          award_name: "",
          point_num: "",
          point_percent: "",
          gift_percent: "",
          bonus_percent: "",
          bonus_is_hit: false,
          gift_is_hit: false,
          point_is_hit: false,
          is_ploy:0
        };
        panes.value = [];
        if(state.template_type == 7){
          getGoalsNum();
          form.value.quantity_type = 3;
        }else{
          visible.value = true;
        }
        giftDetail.value = {}
      };
      var numData = ref({ min_num: 1, max_num: 100 });
      // 获取添加奖项-获取可用的数量
      const getActivitysNum = async () => {
        let result = await activitysNum(props.activity_id,"")
          .then((res) => res.data)
          .catch((error) => error);

        numData.value = result.data;
        if (list.value.length == 7 && state.template_type == 4 && !award_id.value) {
          setTimeout(() => {
            form.value.quantity_type = 2;
            form.value.award_num = numData.value.assig_num;
          }, 1000);
        }
        return;
      };
      const sysAward_icon = [
        "/web_base_assets/scan/reb.png",
        "/web_base_assets/scan/coupons.png",
        "/web_base_assets/scan/cut.png",
        "/web_base_assets/scan/jf.png",
      ];
      // 详情
      const giftDetail = ref();
      const detail = async (award_id) => {
        await getActivitysNum();
        let result = await activitysTreeDetail(award_id)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result)) {
          panes.value = [];
          form.value = result.data;
          // 判断奖项图片是否是系统图片
          if (
            result.data.award_img &&
            sysAward_icon.indexOf(result.data.award_img) == -1
          ) {
            form.value.award_bg = result.data.award_img;
          }
          visible.value = true;
          if (form.value.is_bonus) {
            panes.value.push({
              title: "红包",
              type: "is_bonus",
              key: "is_bonus",
            });
          }
          if (form.value.is_gift) {
            panes.value.push({
              title: "礼品",
              type: "is_gift",
              key: "is_gift",
            });
          }
          if (form.value.is_point) {
            panes.value.push({
              title: "积分",
              type: "is_point",
              key: "is_point",
            });
          }
          if (form.value.is_coupon) {
            panes.value.push({
              title: "优惠卷",
              type: "is_coupon",
              key: "is_coupon",
            });
          }
          console.log(panes);
          giftDetail.value = {
            gift_store_array: result.data.gift_store_array, //门店数据
            gift_is_appoint_store: result.data.gift_is_appoint_store, //0全部门店 指定门店
            gift_effective_day: result.data.gift_effective_day, //礼品有效期
            is_guider: 1, //导购核销 这期没有  0 不开启 1 开启
            gift_content: result.data.gift_content, //礼品描述
            gift_id: result.data.gift_id, //礼品ID
            gift_express_id: result.data.gift_express_id, //运费ID
            gift_type: result.data.gift_type, //1礼品库 2产品库
            gift_is_express: result.data.gift_is_express == 1 ? true : false, //领奖方式
            gift_is_store: result.data.gift_is_store == 1 ? true : false, //领奖方式
            is_entity: result.data.is_entity
          };
        } else {
          message.error(result.message);
        }
      };
      const edit = async (data) => {
        award_id.value = data.award_id;
        detail(data.award_id);
      };
      // 获取list
      const award_percent = ref(0);
      const code_num = ref(0)
      const getList = async () => {
        listLoading.value = true;
        let result = await activitysTreeList(props.activity_id)
          .then((res) => res.data)
          .catch((error) => error);
        listLoading.value = false;
        if (iscode(result)) {
          list.value = result.data;
          award_percent.value = result.award_percent;
          code_num.value = result.code_num;
          if (list.value.length == 7 && state.template_type == 4 && !award_id.value) {
            setTimeout(() => {
              form.value.quantity_type = 2;
              form.value.award_num = numData.value.assig_num;
            }, 1000);
          }
        } else {
          message.error(result.message);
        }
      };
      const changeIsPloy = (e, data) => {
        console.log(e, data)
      }
      // 下一步
      const next = () => {
        emit("setpsTreeNext", 1);
      };
      const provide = () => {
        emit("setpsTreeProvide", 1);
      };
      // 删除
      const del = async (data) => {
        let result = await activitysTreeDel(data.award_id)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          getList();
        }
      };
      const number2Boolean = (number) => {
        return !!number;
      };
      const boolean2Number = (boo) => {
        return boo ? 1 : 0;
      };
      const giftChooseData = ref({});
      const giftDone = (data) => {
        giftChooseData.value = data;
      };
      const giftCompoents = ref();
      // 新增范围
      const handleOk = async () => {
        if (
          !form.value.is_bonus &&
          !form.value.is_gift &&
          !form.value.is_point &&
          !form.value.is_coupon
        ) {
          message.error("请选择奖项内容");
          return;
        }
        if (
          panes.value.length > 1 &&
          !form.value.bonus_is_hit &&
          !form.value.gift_is_hit &&
          !form.value.point_is_hit &&
          !form.value.coupon_is_hit &&
          form.value.is_many_percent
        ) {
          message.error("必得奖项至少勾选一项");
          return;
        }
        ruleForm.value.validate().then(async (res) => {
          var result;
          var json = form.value;
          json.is_gift = boolean2Number(json.is_gift);
          json.is_bonus = boolean2Number(json.is_bonus);
          json.is_point = boolean2Number(json.is_point);
          json.is_coupon = boolean2Number(json.is_coupon);
          confirmLoading.value = true;
          if (json.is_gift) {
            if (!giftChooseData.value) {
              message.error("请完善礼品表单");
              return;
            }
            Object.assign(json, giftChooseData.value);
          }
          if (!json.is_many_percent) {
            json["gift_percent"] = "";
            json["point_percent"] = "";
            json["bonus_percent"] = "";
            json["coupon_percent"] = "";
          } else {
            if (!json.is_gift) {
              json["gift_percent"] = "";
            }
            if (!json.is_point) {
              json["point_percent"] = "";
            }
            if (!json.is_bonus) {
              json["bonus_percent"] = "";
            }
            if (!json.is_coupon) {
              json["coupon_percent"] = "";
            }
          }
          if (award_id.value) {
            result = await activitysTreeUpdate(award_id.value, json)
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            result = await activitysTreeCreate(props.activity_id, json)
              .then((res) => res.data)
              .catch((error) => error);
          }
          if (iscode(result, true)) {
            visible.value = false;
            getList();
            giftChooseData.value = null;
          }
          confirmLoading.value = false;
        });
      };
      // 用于记录 选中的批次 数据
      const batch = ref({});
      const batchChange = (data) => {
        batch.value = data[0];
        form.value.batch_sn = data.map((v) => v.batch_sn);
        console.log(form.value.batch_sn);
      };

      onMounted(() => {
        state.template_type = sessionStorage.getItem("template_type");
        getList();
      });
      // 必得奖项
      const changHit = (type) => {
        console.log(type);
        // switch(type){
        //   case 'point_is_hit':
        //     form.value.gift_is_hit=false
        //     form.value.bonus_is_hit=false
        //   break;
        //     case 'gift_is_hit':
        //     form.value.point_is_hit=false
        //     form.value.bonus_is_hit=false
        //   break;
        //     case 'bonus_is_hit':

        //   break;
        // }
      };
      //附加奖项
      const additionalShow = (data) => {
        state.additionalVisible = true
        state.additionalData = data
      }
      return {
        ...toRefs(state),
        info: store.state.user.info,
        changAwardContent,
        create,
        panes,
        columns,
        listLoading,
        list,
        form,
        award_percent,
        code_num,
        rules,
        ruleForm,
        labelCol,
        wrapperCol,
        del,
        edit,
        handleOk,
        detail,
        next,
        provide,
        visible,
        batch,
        batchChange,
        def,
        numData,
        giftCompoents,
        giftDone,
        award_id,
        giftDetail,
        getActivitysNum,
        getList,
        changHit,
        confirmLoading,
        additionalShow,
        changeIsPloy
      };
    },
  };
</script>
<style lang="less" scoped>
  .ant-form-item {
    margin-bottom: 10px;
  }

  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      margin-right: 10px;
      margin-bottom: 10px;

      label {
        width: 110px;
        height: 110px;
        display: block;
        border: 1px solid transparent;
      }

      input:checked~label {
        border: 1px solid #05486a;
      }
    }
  }
</style>